import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classes from 'classnames'
import './style.css'

class VisibleComponent extends Component {
  componentWillReceiveProps(nextProps) {
    const { visible, onVisibilityChange } = this.props

    if (!onVisibilityChange) {
      return
    }

    if (visible && !nextProps.visible) {
      onVisibilityChange(false)
    }

    if (!visible && nextProps.visible) {
      onVisibilityChange(true)
    }
  }

  render() {
    const { visible, children } = this.props

    return (
      <div className={classes({
        'visible-component-visible': visible,
        'visible-component-hidden': !visible
      })}>
        {children}
      </div>
    )
  }
}

VisibleComponent.propTypes = {
  visible: PropTypes.bool.isRequired,
  onVisibilityChange: PropTypes.func,
}

export default VisibleComponent



// WEBPACK FOOTER //
// ./src/components/shared/VisibleComponent/index.js